import { Box, Typography, Autocomplete, TextField } from "@mui/material"
import Stack from "@mui/material/Stack"
import Button from "@mui/material/Button"
import { lists } from "../../utils"
import useStyles from "./style"
import { Link } from "react-router-dom"
import form from "../../services/form"
import { useEffect, useState } from "react"
import { isEmpty } from "../../validators/validator"

const Home = () => {
  const classes = useStyles()

  const [documentTypeList, setDocumentTypeList] = useState([])

  const [user, setUser] = useState({
    document_number: undefined,
    document_type: undefined,
  })

  const getDocumentType = async () => {
    const response = await form.documentType()
    setDocumentTypeList(response)
  }

  useEffect(() => {
    getDocumentType()
  }, [])

  const handleChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    })
  }

  const handleDisabled = () => {
    try {
      const stateFilter = Object.values(user).filter(
        (item) => item === undefined || item === "" || item.length === 0
      )
      if (stateFilter.length > 0) {
        return true
      } else {
        return false
      }
    } catch (error) {
      return true
    }
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.body}>
        <Box className={classes.bodyHead}>
          <Box className={classes.bodyHeadTitle}>
            <Typography variant="h1" className={classes.title}>
              ¡BIENVENIDO!
            </Typography>
            <Typography variant="h1" className={classes.title}>
              TE ENCUENTRAS EN NUESTRA PLATAFORMA
            </Typography>
            <Typography variant="h1" className={classes.title}>
              DE GESTIÓN DE PQRSF
            </Typography>
          </Box>
          <Box className={classes.bodyParraf}>
            <Typography variante="caption" className={classes.parraf}>
              Vamos a asistirle en la creación de su primera PQRSF.
            </Typography>
            <Typography variante="caption" className={classes.parraf}>
              Nos complace atender a nuestros usuarios con la mejor calidad.
              Permítanos saber en qué podemos ayudarle y cómo podemos mejorar.
            </Typography>
            <Typography variante="caption" className={classes.parraf}>
              Por favor introduce el tipo y número de documento para iniciar con
              la gestión.
            </Typography>
          </Box>
          <Box className={classes.boxs}>
            <Box className={classes.documentTypeContainer}>
              <Autocomplete
                disablePortal
                name="document_type"
                onChange={(_, value) => {
                  handleChange({ target: { name: "document_type", value } })
                }}
                value={user?.document_type ? user.document_type : null}
                options={documentTypeList?.value || []}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo de documento *"
                    error={
                      user?.document_type === undefined
                        ? false
                        : isEmpty(user?.document_type) || false
                    }
                  />
                )}
              />
              <Box className={classes.errorContainer}>
                {user?.document_type === undefined
                  ? false
                  : isEmpty(user?.document_type) && (
                      <Typography variant="caption" color="error">
                        {lists.errors.documentType}
                      </Typography>
                    )}
              </Box>
            </Box>
            <Box className={classes.documentNumContainer}>
              <TextField
                label="Número de documento *"
                variant="outlined"
                className={classes.documentN}
                fullWidth
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9.]/, "")
                    .replace(/(\..*)\./g, "$1")
                }}
                name="document_number"
                onChange={handleChange}
                value={user?.document_number ? user.document_number : ""}
                error={
                  user?.document_number === undefined
                    ? false
                    : isEmpty(user?.document_number) || false
                }
              />
              <Box className={classes.errorContainer}>
                {user?.document_number === undefined
                  ? false
                  : isEmpty(user?.document_number) && (
                      <Typography variant="caption" color="error">
                        {lists.errors.documentNum}
                      </Typography>
                    )}
              </Box>
            </Box>
          </Box>
          <Stack
            spacing={2}
            direction="row"
            className={classes.buttonContainer}
          >
            <Button
              variant="contained"
              className={classes.button}
              disabled={handleDisabled()}
              component={Link}
              to={`/form/${user.document_type}/${user.document_number}`}
            >
              NUEVA PQRSF
            </Button>
          </Stack>
        </Box>
      </Box>

      <Box className={classes.bg}></Box>
    </Box>
  )
}

export default Home
